<mat-card appearance="outlined" class="mission-card" *ngIf="!onEditMode">
  <mat-card-header>
    <mat-card-title>
      <div class="actionsCardTitle">
        <a (click)="getBack()" class="linkGetBack">
          <mat-icon>navigate_before</mat-icon> retour
        </a>
        <div [matTooltip]="invalidMessage" [matTooltipDisabled]="canEdit">
          <button
            *ngIf="!order.isDeleted"
            mat-raised-button
            class="action-button"
            color="primary"
            [disabled]="isLoading || !canEdit"
            matTooltip="Modifier l'abonnement"
            (click)="updateOrder()"
          >
            Modifier l'abonnement
          </button>
        </div>
      </div>
      <h3>Infos de l'abonnement</h3>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <section class="wrapperContainer">
      <ul class="left-list listHeader">
        <li class="created-by" *ngIf="!isRestricted">
          Créé le {{ order.createdOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
          par
          <span class="username" *ngIf="order.createdBy">{{
            order.createdBy.username
          }}</span>
          <span class="username" *ngIf="!order.createdBy">Système</span>
          <ng-container *ngIf="order.modifiedOn">
            , <br />
            Modifié le
            {{ order.modifiedOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
            par
            <span class="username" *ngIf="order.modifiedBy">{{
              order.modifiedBy.username
            }}</span>
            <span class="username" *ngIf="!order.modifiedBy">Système</span>
          </ng-container>
        </li>

        <li *ngIf="order.cronExpression">
          <span class="label">Fréquence de création</span>
          <span *ngIf="order.cronDescription">{{ order.cronDescription }}</span>
        </li>

        <li *ngIf="!order.cronExpression && order.scheduledDate">
          <span class="label">Date de création</span>
          <span>{{ order.scheduledDate | amDateFormat: "DD/MM/YYYY HH:mm" }}</span>
        </li>

        <li *ngIf="order.cronExpression">
          <span class="label">Jour férié</span>
          <span>
            {{ order.isActiveOnHolidays ? "Oui" : "Non" }}
          </span>
        </li>

        <li *ngIf="order.cronExpression">
          <span class="label">Heure de départ</span>
          <span>{{ order.startTime }}</span>
        </li>

        <li *ngIf="!order.cronExpression && order.orderStartDate">
          <span class="label">Date de départ</span>
          <span>{{ order.orderStartDate | amDateFormat: "DD/MM/YYYY HH:mm" }}</span>
        </li>

        <li class="siteSection">
          <span class="label">Donneur d'ordre</span>
          <span *ngIf="order.site">{{ order.site.name }}</span>
        </li>

        <li>
          <span class="label">Nom du demandeur</span>
          <span *ngIf="order.ordererName">{{ order.ordererName }}</span>
        </li>

        <li>
          <span class="label">Téléphone du demandeur</span>
          <span *ngIf="order.ordererPhone">{{ order.ordererPhone }}</span>
        </li>

        <li>
          <span class="label">Type de commande</span>
          <span>
            {{ showTypeText(order.type) | translate }}
            <span *ngIf="!order.cronExpression" class="ponctual-badge">
              Ponctuelle
            </span>
          </span>
        </li>

        <li *ngIf="order.name">
          <span class="label">Nom</span>
          <span>
            {{ order.name }}
          </span>
        </li>

        <li *ngIf="isTour()">
          <span class="label">Code tournée</span>
          <span>{{ order.code }}</span>
        </li>

        <li *ngIf="isTour()">
          <span class="label">Prix</span>
          <span *ngIf="order.price"> {{ order.price }} € </span>
        </li>

        <li *ngIf="isTour()">
          <span class="label">Prix (étapes supplementaires)</span>
          <span *ngIf="order.extraStepPrice">
            {{ order.extraStepPrice }} €
          </span>
        </li>
      </ul>

      <ul class="middle-list listHeader">
        <li>
          <span class="label">Niveau d'urgence</span>
          <span *ngIf="order.urgency">{{ order.urgency.name }}</span>
        </li>

        <li>
          <fieldset>
            <legend class="label">Type de produits</legend>
            <ul *ngIf="order.transportTypes.length > 0">
              <li *ngFor="let type of order.transportTypes">{{ type.name }}</li>
            </ul>
            <span *ngIf="order.transportTypes.length === 0"
              >Aucun type de produits</span
            >
          </fieldset>
        </li>

        <li class="global-comment" *ngIf="order.ordererComment">
          <fieldset>
            <legend class="label">Commentaire</legend>
            <p class="comment" *ngIf="order.ordererComment">
              {{ order.ordererComment }}
            </p>
          </fieldset>
        </li>
      </ul>

      <ul class="right-list listHeader">
        <li>
          <span class="label">Agence</span>
          <span *ngIf="order.client">{{ order.client.name }}</span>
        </li>

        <li *ngIf="order.status !== 16">
          <span class="label">Nombre de destination(s)</span>
          <span>{{ totalSteps }}</span>
        </li>

        <li *ngIf="order.driver">
          <span class="label">Chauffeur</span>
          <span>{{ order.driver.username }}</span>
        </li>
      </ul>
    </section>
  </mat-card-content>
  <mat-card-actions>
    <mat-progress-bar
      class="progress-bar"
      mode="indeterminate"
      color="primary"
      *ngIf="isLoading"
    ></mat-progress-bar>
  </mat-card-actions>
</mat-card>

<div class="actionsToggle" *ngIf="!onEditMode">
  <button mat-button (click)="accordion.openAll()">Tout développer</button>
  <button mat-button (click)="accordion.closeAll()">Tout réduire</button>
</div>
<mat-accordion class="example-headers-align" multi *ngIf="!onEditMode">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span *ngIf="!isTour()">Expédition -&nbsp;</span>
        Étape 1
      </mat-panel-title>
      <mat-panel-description>
        <span class="italic" *ngIf="!isTour()"> Enlèvement</span>
        <mat-icon color="primary" *ngIf="!isTour()">local_shipping</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="wrapperStep">
      <ul class="listPanel">
        <li *ngIf="order.sender.address">
          <span class="label">Nom d'adresse </span
          >{{ order.sender.address.name }}
        </li>
        <li *ngIf="order.sender.otherAddress">
          <span class="label">Nom d'adresse </span
          >{{ order.sender.otherAddress }}
        </li>
        <li *ngIf="order.sender.service">
          <span class="label">Service </span>{{ order.sender.service }}
        </li>
        <li *ngIf="order.sender.hasSignature">
          <span class="label">Signataire </span>{{ order.sender.signatory }}
        </li>
        <li *ngIf="order.sender.requestedTime">
          <span class="label">Heure de passage souhaitée </span
          >{{
            convertToISODate(order.sender.requestedTime) | amDateFormat: "HH:mm"
          }}
        </li>
        <li *ngIf="order.sender.hasSignature">
          <button
            mat-raised-button
            color="primary"
            (click)="downloadSignature(order.sender)"
          >
            Télécharger signature
          </button>
        </li>
      </ul>

      <ul>
        <!-- <li *ngIf="order.sender.address">
          <span class="label">Adresse complète </span>
          <span>{{order.sender.address.street}} {{order.sender.address.streetNumber}} {{order.sender.address.locality}}
            {{order.sender.address.postalCode}}</span>
        </li> -->
      </ul>

      <ul>
        <li>
          <fieldset>
            <legend class="label">Commentaire client/dispatcheur</legend>
            <p *ngIf="order.sender.ordererComment">
              {{ order.sender.ordererComment }}
            </p>
            <p *ngIf="!order.sender.ordererComment">Aucun</p>
          </fieldset>
        </li>
      </ul>
    </section>

    <mat-datepicker #picker></mat-datepicker>
  </mat-expansion-panel>

  <ng-container>
    <mat-expansion-panel
      *ngFor="let receiver of order.receivers; index as i"
      [expanded]="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span *ngIf="!isTour() && receiver.isPickup"
            >Expédition - &nbsp;</span
          >
          <span *ngIf="!isTour() && receiver.isDelivery"
            >Destinataire - &nbsp;</span
          >
          Étape {{ i + 2 }}
        </mat-panel-title>
        <mat-panel-description>
          <span class="italic" *ngIf="!isTour() && receiver.isPickup"
            >Enlèvement</span
          ><span class="italic" *ngIf="!isTour() && receiver.isDelivery"
            >Livraison</span
          >
          <mat-icon *ngIf="!isTour() && receiver.isPickup" color="primary">
            local_shipping
          </mat-icon>
          <mat-icon *ngIf="!isTour() && receiver.isDelivery" color="primary">
            location_on
          </mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <section class="wrapperStep">
        <ul class="listPanel">
          <li *ngIf="receiver.address">
            <span class="label">Nom d'adresse </span>{{ receiver.address.name }}
          </li>
          <li *ngIf="receiver.otherAddress">
            <span class="label">Nom d'adresse </span>{{ receiver.otherAddress }}
          </li>
          <li *ngIf="receiver.service">
            <span class="label">Service </span>{{ receiver.service }}
          </li>
          <li *ngIf="receiver.requestedTime">
            <span class="label">Heure de passage souhaitée </span>
            {{
              convertToISODate(receiver.requestedTime) | amDateFormat: "HH:mm"
            }}
          </li>
        </ul>

        <ul>
          <!-- <li *ngIf="receiver.address">
            <span class="label">Adresse complète </span> {{receiver.address.street}} {{receiver.address.streetNumber}}
            {{receiver.address.locality}} {{receiver.address.postalCode}}
          </li> -->
        </ul>

        <ul>
          <li>
            <fieldset>
              <legend class="label">Commentaire client/dispatcheur</legend>
              <p *ngIf="receiver.ordererComment">
                {{ receiver.ordererComment }}
              </p>
              <p *ngIf="!receiver.ordererComment">Aucun</p>
            </fieldset>
          </li>
        </ul>
      </section>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>

<app-recurring-order-edit
  *ngIf="onEditMode"
  [order]="order"
  (editFinished)="onEditFinished()"
></app-recurring-order-edit>
